import React from 'react'

// import styles from './styles.module.scss'

const HeaderSpacing = () => {
  // return <div className={styles.space} />
  return <></>
}

export default HeaderSpacing
